module.exports = __webpack_public_path__ + "/images/ln-hero-af-biberon.8e88d17.png";